import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import { get, TextBody } from '@ally/metronome-ui';
const sharedListItemStyles = css `
  margin: ${get.space('sm')} 0;
  padding-left: ${get.space('lg')};
  font-size: 14px;
  line-height: 1.5;
`;
export const StyledTextBody = styled(TextBody)(space);
export const UL = styled.ul `
  && {
    list-style: disc;
    ${sharedListItemStyles}
  }
`;
export const OL = styled.ol `
  && {
    ${sharedListItemStyles}
  }
`;
export const LI = styled.li `
  margin-bottom: ${get.space('xs')};
  &:last-of-type {
    margin-bottom: 0;
  }
`;
export const OLLI = styled.li `
  margin-bottom: ${get.space('xxs')};
  padding-left: ${get.space('xs')};
  &:last-of-type {
    margin-bottom: 0;
  }
`;
export const StyledDL = styled.dl `
  margin: 0;
`;
export const StyledDT = styled.dt `
  font-size: ${get.fontSizes('xs')};
  font-weight: bold;
  ${get.media.down('md')} {
    margin: 0;
  }
`;
export const StyledDD = styled.dd `
  font-size: ${get.fontSizes('sm')};
  margin: 0 0 ${get.space('md')} 0;
  &:last-of-type {
    margin: 0;
  }
  ${get.media.down('md')} {
    padding: 0;
  }
`;
export const IconWrapper = styled.div `
  display: flex;
  margin-right: ${get.space('xs')};
  margin-top: 2px;
`;
export const NeedsAttentionContainer = styled(TextBody) `
  display: flex;
  align-items: flex-start;
`;
//# sourceMappingURL=SharedStyles.js.map